import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { AuthenticationService } from '../../../common/user-management/auth-management/authentication/services/authentication.service';
import { UserContextService } from '../../../common/user-management/auth-management/authentication/services/user-context.service';

export const AuthGuard: CanActivateFn = (route, state) => {
  const authService = inject(AuthenticationService);
  if (UserContextService.isAuthenticated()) {
    return true;
  } else {
    authService.logout();
    return false;
  }
};
